export const StatusSelect = ({ value, options, onChange, testid }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
    className="rounded-full border border-white/20 bg-[#101017] px-3 py-1.5 text-sm font-bold capitalize text-white outline-none focus:border-[var(--pink)]">
    {options.map((o) => <option key={o} value={o}>{o.replace("_", " ")}</option>)}
  </select>
);

const PAY_COLORS = { paid: "bg-emerald-500/20 text-emerald-300", pending: "bg-yellow-500/20 text-yellow-300", failed: "bg-red-500/20 text-red-300", refunded: "bg-white/10 text-white/70" };

export const PayBadge = ({ status, testid }) => (
  <span className={`rounded-full px-3 py-1 text-xs font-extrabold capitalize ${PAY_COLORS[status] || PAY_COLORS.refunded}`} data-testid={testid}>{status}</span>
);

export const fmtDate = (iso) => new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
